package components

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.EaseInOut
import androidx.compose.animation.core.EaseInOutCirc
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.duoma.duomaproducao.ui.misc.mediaQuery
import duomaproducao.composeapp.generated.resources.Res
import duomaproducao.composeapp.generated.resources.duo_logo
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource

@Composable
fun CompanyLogo(modifier: Modifier = Modifier) {
    Image(
        painter = painterResource(Res.drawable.duo_logo),
        contentDescription = "Duoma logo",
//        contentScale = ContentScale.FillWidth,
        modifier = modifier
        ,
        colorFilter = ColorFilter.tint(Color.White)
    )
}

@Composable
 fun AppHeader(showBack : Boolean, isLoading: Boolean, onBack : () -> Unit, onUpdate : () -> Unit) {
    val rotation = remember { Animatable(0f) }
    val uiScope = rememberCoroutineScope()
    val ioScope = rememberCoroutineScope { Dispatchers.Default }
    LaunchedEffect(isLoading) {
        if (isLoading) {
            while (true) {
                rotation.animateTo(360f, tween(1000, easing = EaseInOutCirc))
                rotation.snapTo(0f)
            }
        } else {
            rotation.snapTo(0f)
        }
    }


    Box(
        Modifier
            .fillMaxWidth()
            .background(MaterialTheme.colorScheme.primary)
            .padding(horizontal = mediaQuery(32.dp, 12.dp), vertical = mediaQuery(
                20.dp,
                12.dp
            )
            ),
    ) {
        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.align(Alignment.TopCenter).width(1350.dp)) {
            AnimatedVisibility(showBack) {
                IconButton(onClick = onBack, modifier = Modifier.padding(end = mediaQuery(
                    24.dp,
                    0.dp
                )
                )) {
                    Icon(Icons.AutoMirrored.Filled.ArrowBack, "Voltar", tint = Color.White)
                }
            }
            mediaQuery<@Composable () -> Unit>(
                ::DesktopTitles,
                ::MobileTitles
            )()
            Spacer(Modifier.weight(1f))
            IconButton(
                onClick = {
                        onUpdate()
                }
            ) {
                Icon(Icons.Default.Refresh, "Atualizar",
                    modifier =  Modifier.rotate(rotation.value),
                    tint = Color.White)
            }
        }
    }
}
@Composable
private fun DesktopTitles() {
    Row (verticalAlignment = Alignment.CenterVertically) {
        CompanyLogo(Modifier.width(200.dp))
        Spacer(Modifier.width(24.dp))
        Column {
            Text(
                text = "Painel de Produção",
                style = MaterialTheme.typography.headlineSmall,
                fontWeight = FontWeight.Bold,
                color = Color.White
            )
            Spacer(Modifier.height(2.dp))
            Text(
                text = "Acompanhamento em tempo real",
                style = MaterialTheme.typography.bodyMedium,
                color = Color.White.copy(alpha = 0.70f)
            )
        }
    }
}
@Composable
private fun MobileTitles() {
    Column {
        CompanyLogo(Modifier.width(80.dp))
        Spacer(Modifier.height(2.dp))
        Text(
            text = "Painel de Produção",
            style = MaterialTheme.typography.headlineSmall,
            fontWeight = FontWeight.Bold,
            color = Color.White
        )
        Spacer(Modifier.height(2.dp))
        Text(
            text = "Acompanhamento em tempo real",
            style = MaterialTheme.typography.bodyMedium,
            color = Color.White.copy(alpha = 0.70f)
        )
    }
}
